export default "<ng-container #secondaryContainer></ng-container>"